export var referrerMapper = function (referrerId, linkName, eventType) {
  if (eventType === void 0) {
    eventType = 'click';
  }
  return {
    schemaName: 'referrer',
    messageContent: {
      referrerId: referrerId,
      linkName: linkName,
      eventType: eventType
    }
  };
};